export default "__VITE_ASSET__BroKl5zT__"